<template>

  <a-modal
    :title="$t('accountSettings.updateAvatar')"
    :visible="visible"
    :maskClosable="false"
    :confirm-loading="submitLoading"
    :width="800"
    :footer="null"
    @cancel="cancelHandel">
    <a-row>
      <a-col :xs="24" :md="12" :style="{height: '350px'}">
        <vue-cropper
          ref="cropper"
          :img="options.img"
          :info="true"
          :autoCrop="options.autoCrop"
          :autoCropWidth="options.autoCropWidth"
          :autoCropHeight="options.autoCropHeight"
          :fixedBox="options.fixedBox"
          @realTime="realTime"
        >
        </vue-cropper>
      </a-col>
      <a-col :xs="24" :md="12" :style="{height: '350px'}">
        <div class="avatar-upload-preview">
          <a-avatar :size ="180" :src="previews.url" :style="previews.img"/>
        </div>
      </a-col>
    </a-row>
    <br>
    <a-row>
      <a-col :lg="2" :md="2">
        <a-upload 
          name="file" 
          :beforeUpload="beforeUpload" 
          :showUploadList="false"
        >
          <a-button icon="upload">{{ $t('accountSettings.selectImage') }}</a-button>
        </a-upload>
      </a-col>
      <a-col :lg="{span: 1, offset: 2}" :md="2">
        <a-button icon="plus" @click="changeScale(1)"/>
      </a-col>
      <a-col :lg="{span: 1, offset: 1}" :md="2">
        <a-button icon="minus" @click="changeScale(-1)"/>
      </a-col>
      <a-col :lg="{span: 1, offset: 1}" :md="2">
        <a-button icon="undo" @click="rotateLeft"/>
      </a-col>
      <a-col :lg="{span: 1, offset: 1}" :md="2">
        <a-button icon="redo" @click="rotateRight"/>
      </a-col>
      <a-col :lg="{span: 2, offset: 6}" :md="2">
        <a-button type="primary" :loading="uploading" @click="finish('blob')">{{ $t('common.save') }}</a-button>
      </a-col>
    </a-row>
  </a-modal>

</template>
<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import UploadFileToVOD from '@/api/vod.js'

export default {
  data () {
    return {
      visible: false,
      id: null,
      submitLoading: false,
      fileList: [],
      uploading: false,
      options: {
        img: '',
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true
      },
      previews: {},
      fileName: ''
    }
  },
  computed: {
    ...mapGetters(['avatar'])
  },
  methods: {
    edit (id) {
      this.visible = true
      this.id = id
      /* 获取原始头像 */
      this.imgTrick(this.avatar)
    },

    //处理跨域
    imgTrick(src) {
      let image = new Image();
      let _this = this;
      image.src = src + '?timeStamp=' + Math.random();
      image.crossOrigin = 'Anonymous'; // 支持跨域图片
      image.onload = function() {
        let canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        let ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, image.width, image.height);
        _this.options.img =  canvas.toDataURL('image/png'); // 可选其他值 image/jpeg
      } ;
    },
    close () {
      this.id = null
      this.visible = false
      this.options.img = ''
      this.previews = {}
    },
    cancelHandel () {
      this.close()
    },
    changeScale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    beforeUpload (file) {
      const fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('accountSettings.uploadImageWarning'))
        return false
      }
      const reader = new FileReader()
      // 转化为base64，用于在裁剪器中显示
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.options.img = reader.result
      }
      this.fileName = file.name
      return false
    },

    // 上传图片（点击保存按钮，上传裁剪后的图片）
    finish (type) {
      const _this = this
      this.uploading = true
      
      // 输出裁剪后的图片
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob((data) => {
          // 将裁剪后的blob转换为File对象
          const file = new File([data], this.fileName || 'avatar.png', { type: 'image/png' })
          
          // 上传裁剪后的图片到腾讯云点播
          new UploadFileToVOD([file], {
            success: function (fileName) {
              const avatarUrl = fileName[0]
              // 更新store中的头像
              store.commit('SET_AVATAR', avatarUrl)
            _this.$message.success(_this.$t('accountSettings.uploadSuccess'))
              _this.$emit('ok', avatarUrl)
            _this.visible = false
              _this.uploading = false
            },
            error: function (error) {
              _this.uploading = false
              _this.$message.error(_this.$t('accountSettings.uploadFailed'))
              console.error('上传失败:', error)
            }
          })
        })
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.model = true
          this.modelSrc = data
          this.uploading = false
        })
      }
    },
    okHandel () {
      const vm = this

      vm.submitLoading = true
      setTimeout(() => {
        vm.submitLoading = false
        vm.close()
        vm.$message.success(vm.$t('accountSettings.uploadAvatarSuccess'))
      }, 2000)
    },

    realTime (data) {
      console.log(data)
      this.previews = data
    }
  }
}
</script>

<style lang="less" scoped>

  .avatar-upload-preview {
    position: absolute;
    top: 50%;
    transform: translate(50%, -50%);
    width: 180px;
    height: 180px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>
